module.exports = __webpack_public_path__ + "static/media/student-snapshort1-logout.7528c1b7.png";